import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {IUser} from '../../auth/auth.service';
import {IRole} from '../../auth/role';
import {PaginatedResponse} from '../../shared/interfaces';

export interface IUpdateUserRolesRequest {
    id: number;
    roles: number[];
}

@Injectable()
export class UserService {

    constructor(
        private _http: HttpClient
    ) {
    }

    roles(): Observable<IRole[]> {
        return <any>this._http.get(`${environment.api}/roles`);
    }

    list(): Observable<PaginatedResponse<IUser>> {
        return <any>this._http.get(`${environment.api}/users`);
    }

    page(url): Observable<PaginatedResponse<IUser>> {
        return <any>this._http.get(url);
    }

    sync(request: IUpdateUserRolesRequest): Observable<IUser> {
        return <any>this._http.put(`${environment.api}/users/${request.id}`, request);
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/administration/users/user.service.ts